const REGIONAL_INDICATOR_A = 0x1f1e6;
const REGIONAL_INDICATOR_Z = REGIONAL_INDICATOR_A + 25;
const ASCII_A = 0x41;

export function getCountryCodeFromFlag(flag) {
  if (!flag || flag === '🌐') return null;

  const chars = [...flag];
  if (chars.length !== 2) return null;

  const codePoints = chars.map((char) => char.codePointAt(0));
  if (codePoints.some((cp) => typeof cp !== 'number' || cp < REGIONAL_INDICATOR_A || cp > REGIONAL_INDICATOR_Z)) {
    return null;
  }

  const code = codePoints
    .map((cp) => String.fromCharCode(ASCII_A + (cp - REGIONAL_INDICATOR_A)))
    .join('');

  return /^[A-Z]{2}$/.test(code) ? code : null;
}
